export default defineNuxtPlugin(async () => {
  const { fetchCart } = useCart()
  await fetchCart()
})
